module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/og_page4.15393158.jpg";